import React, {useState, useMemo} from 'react';
import DataTable, {createTheme} from 'react-data-table-component';

import '../../assets/styles/App.css';
import "@fontsource/montserrat";

const TableSearchChart = ({data, columns}) => {
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    const customStyles = {
        headRow: {
            style: {
                border: 'none',
            },
        },
        headCells: {
            style: {
                color: '#202124',
                backgroundColor: '#FFE600',
                // fontSize: '14px',
                fontWeight: 'bold',
                paddingLeft: '8px',
                paddingRight: '8px',
                justifyContent: 'left',
                wordWrap: 'breakWord',
            },
        },
        pagination: {
            style: {
                border: 'none',
                minHeight: '56px',
                svg: {
                    top: '5px',
                    width: '35px',
                    height: '33px',
                    padding: '3px',
                },
            },
            pageButtonsStyle: {
                height: '40px',
                width: '80px',
                padding: '8px',
                svg: {
                    margin: 'auto',
                    width: '24px',
                    height: '24px',
                },

            },
        },
    };

    createTheme(
        'jumo',
        {
            text: {
                primary: '#ffffff',
                secondary: '#FFE600',
            },
            background: {
                default: '#152065',
            },
            context: {
                background: '#000039',
                text: '#FFFFFF',
            },
            divider: {
                default: '#0074E0',
            },
            button: {
                default: '#FFE600',
                hover: 'rgba(0,0,0,.08)',
                focus: 'rgba(255,255,255,.12)',
                disabled: 'rgba(255, 255, 255, .34)',
            },
            header: {
                style: {
                    fontSize: '22px',
                    color: '#FFE600',
                    backgroundColor: '#152065',
                    minHeight: '56px',
                    paddingLeft: '16px',
                    paddingRight: '8px',
                },
            },
            sortFocus: {
                default: '#2aa198',
            },
        },
        'dark',
    );

    const filteredItems = data.filter(
        (item) =>
            item && columns.some(column => {
                const accessor = column.selector;
                if (!accessor) return false;

                const value = typeof accessor === 'function' ? accessor(item) : item[accessor];

                return value && String(value).toLowerCase().includes(filterText.toLowerCase());
            })
    );

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };

        return (
            <div style={{padding: '8px'}}>
                <input
                    type="text"
                    placeholder="Search..."
                    aria-label="Search Input"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                    style={{width: '200px', padding: '8px', border: '1px solid #ccc', borderRadius: '4px'}}
                />
                <button onClick={handleClear} style={{marginLeft: '8px', color: '#FFE601'}}>Clear</button>
            </div>
        );
    }, [filterText, resetPaginationToggle]);

    const ExpandedComponent = ({ data }) => <pre>{JSON.stringify(data, null, 2)}</pre>;



    return (
        <DataTable
            columns={columns}
            data={filteredItems}
            customStyles={customStyles}
            pagination
            paginationResetDefaultPage={resetPaginationToggle}
            subHeader
            subHeaderComponent={subHeaderComponentMemo}
            expandableRows
            expandableRowsComponent={ExpandedComponent}
            persistTableHead
            highlightOnHover
            dense
            theme="jumo"
        />
    );
};

export default TableSearchChart;